<template>
  <div class="custom-auto-complete" :class="cssClass">
    <span class="auto-complete-primary">{{ description }}</span>
    <span class="auto-complete-secondary">{{ code }}</span>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: [String, Number],
    },
    code: {
      type: [String, Number],
    },
    cssClass: {
      type: String,
      default: () =>{
        return 'css-class'
      }
    },
    data: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {};
  },
  created() {
  },
};
</script>

<style lang="scss">
.custom-auto-complete {
  .auto-complete-secondary {
    padding-left: 5px;
    font-size: 10px;
    color: gray;
  }
  .no-padding {
    padding-left: 0 !important;
  }
}

.custom-word-wrap {
  // .auto-complete-primary {
     word-wrap: break-word;  
    white-space: normal;  
  // }
}
</style>
